import axiosClient from './utils/axiosClient';

export function runJavaCode(body) {
    return axiosClient.post('run/java', body).then((response) => response.data);
}

